import React, { useEffect, useState } from 'react'
import { useCssStyle } from '../../customHook/getCssStyle'
import { useDispatch, useSelector } from 'react-redux';
import { setGoHome, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { cancelWayBooking, createWayBooking, fetchBookings, getAvailbility, getEvents, getEventsInfo, updateMyWayBooking } from '../../Redux/Actions/activitiesAction';
import ActivitiesEventList from './activitiesEventList';
import InfoPopupModal from '../../components/infoPopupModal';
import ActivitiesCreateBooking from './activitiesCreateBooking';
import ActivitiesAdditionalDetails from './activitiesAdditionalDetails';
import ActivititiesConfirmation from './activititiesConfirmation';
import ActivitiesBookings from './activitiesBookings';
import ActivitiesConfirmBooking from './activitiesConfirmBooking';
import { calculateTimeDifference, generateToken } from '../../utils/Helper';
import { CLICKED, EXIT, INITIAL_LOADER_SCREEN, WAY_ACTIVITIES } from '../../config/Constant';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import ActivitiesBookingOverviewPage from './activitiesBookingOverviewPage';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import ActivitiesEventList2 from './activitiesEventList2';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';


const WAY_MY_BOOKING = "MY_BOOKING";
const WAY_EVENT_LIST = 'EVENT_LIST';
const WAY_SUB_EVENT_LIST = 'SUB_EVENT_LIST';

const WAY_SLOT_BOOKING = "SLOT_BOOKING";
const WAY_ADDITIONAL_DETAILS = "ADDITIONAL_DETAILS";
const WAY_CREATE_BOOKING = "CREATE_BOOKING";


const Activities = () => {
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const [waySessionToken, setWaySessionToken] = useState(() => generateToken("way_activities_"));
    let widgetLaunchTime = new Date;

    const [currentPage, setCurrentPage] = useState("activitiesLevel0");
    const [loaderState, setLoaderState] = useState({
        showLoader: "",
        loaderMessage: ""
    });
    const [initialLoading, setInitialLoading] = useState(true);
    const [bookingOverviewDetails, setBookingOverviewDetails] = useState(null);
    const { isLoggedIn } = useSelector(state => state.appConfigSlice);
    

    const [myBookings, setMyBookings] = useState(null);

    const [selectedEvent, setSelectedEvent] = useState({
        event: null,
        eventInfo: null,
        selectedDate: "",
    });

    const [availability, setAvailability] = useState({
        availability: null,
        availableVisibleTimeSlots: null 
    });

    const [participantCount, setParticipantCount] = useState(null)
    const handleUpdatedSelectedEventObj = (data) => {
        setSelectedEvent((prev)=>({
            ...prev,
            ...data
        }))
    }

    const [fetchApiError, setFetchApiError] = useState({
        errorStatus: false,
        errorMessageTitle: "",
        errorMessage: "",
        onContinueFunc: null,
        primaryBtnLabel: "",
        onCloseFunc: null,
        secondaryBtnLabel: ""
    });

    const updateFetchApiError = (errorStatus, errorMessage, onContinueFunc=null, primaryBtnLabel, onCloseFunc=null, secondaryBtnLabel, errorMessageTitle) => {
        setFetchApiError({
            errorStatus,
            errorMessageTitle: errorMessageTitle ? errorMessageTitle : "",
            errorMessage: errorStatus ? errorMessage : "",
            onContinueFunc: errorStatus ? onContinueFunc : null,
            primaryBtnLabel: errorStatus ? primaryBtnLabel : "",
            onCloseFunc: errorStatus ? onCloseFunc : null,
            secondaryBtnLabel: errorStatus ? secondaryBtnLabel : ""
        });
    }

    const updateLoaderState = (loading, message) => {
        setLoaderState({
            showLoader: loading,
            loaderMessage: message
        })
    }

    const updateAvailability = (availability, availableVisibleTimeSlots) => {
        setAvailability({
            availability,
            availableVisibleTimeSlots
        })
    }
    const resetAvailability = () => {
        setAvailability({
            availability: null,
            availableVisibleTimeSlots: null 
        })
    }

    const resetSelectedEvent = () => {
        setSelectedEvent({
            events: selectedEvent?.events,
            categories: selectedEvent?.categories,
            event: null,
            eventInfo: null,
            selectedDate: ""
        })
    }

    const getPriceTierName = () =>{
        let result =[];

        for(const eachPriceTier of selectedEvent.priceTiers ){
            for(let i=0; i < eachPriceTier.quantity ;i++){
                result.push(eachPriceTier.name);
            }
        }

        return result;
    }


    const handleEventClick = async (event, category) => {
        try {
            updateLoaderState(true);

            const { eventInfo, error } = await dispatch(getEventsInfo(event.id, event?.kind));

            updateLoaderState(false);

            if(error){
                updateFetchApiError(true, error);
                dispatch(sendAnalytics(WAY_ACTIVITIES, "FETCH EVENTS INFO - FAILED", { element: "widget", "pageName": WAY_EVENT_LIST, widgetSessionId: waySessionToken, errorMessage: error }));
                return
            }

            handleUpdatedSelectedEventObj({ event, eventInfo, category });
            
            dispatch(sendAnalytics(WAY_ACTIVITIES, "FETCH EVENTS INFO - SUCCESS", { element: "widget", "pageName": WAY_EVENT_LIST, widgetSessionId: waySessionToken }))

            if(!eventInfo?.resourceGroups){
                handleGetAvailability(event);
            }

            handleNext(event);
        } catch (err) {
            // console.log(err)
            updateFetchApiError(true, err.message || "Something went wrong");
            updateLoaderState(false);
        } finally {
            // updateLoaderState(false);
        }
    };

    const getAvailabilityCallback = (status, data) => {
        updateLoaderState(false);

        if(!status){
            dispatch(sendAnalytics(WAY_ACTIVITIES, "GET AVAILABILITY - FAILED", { element: "widget", "pageName": WAY_SUB_EVENT_LIST, widgetSessionId: waySessionToken, errorMessage: data }));
            
            updateFetchApiError(true, data, () => {
                updateFetchApiError(false);

                if(selectedEvent?.event?.kind === "resource") {
                    setCurrentPage("activitiesLevel2");
                    return
                }
                setCurrentPage("activitiesLevel1")
            });
            return
        }

        const sessions = data?.sessions;
 
        const visibleTimeSlots = {};
        const availableVisibleTimeSlots = [];

        for(const item of sessions){
            const date = item?.date;

            for(const session of item?.sessions){
                const key = date + session.startTime + session.endTime;
    
                if (visibleTimeSlots.hasOwnProperty(key)) {
                    const currentEntry = visibleTimeSlots[key];
                    const updatedEntry = [...currentEntry, session];
                    visibleTimeSlots[key] = updatedEntry;
                } else {
                    visibleTimeSlots[key]= [session];
                }
            }
            availableVisibleTimeSlots.push({ date: date, visibleTimeSlots })
        }

        dispatch(sendAnalytics(WAY_ACTIVITIES, "GET AVAILABILITY - SUCCESS", { element: "widget", "pageName": WAY_SUB_EVENT_LIST, widgetSessionId: waySessionToken}));
        updateAvailability(availability, availableVisibleTimeSlots)
    }

    const handleGetAvailability = (event) => {
        try {
            handleUpdatedSelectedEventObj({subEvent: event});

            updateLoaderState(true, "Fetching availability...");
            dispatch(getAvailbility(selectedEvent?.event?.id || event?.id, event?.experiencesIds, getAvailabilityCallback, selectedEvent?.event?.kind));

        } catch (error) {
            // console.log(error)
            updateFetchApiError(true, error.message || "Something went wrong")
        }
    }

    const handleCreateBooking = async (financeInfo) => {
        try {
            updateLoaderState(true);
            const priceTiersName = getPriceTierName();

            const payload = {
                "data": [ 
                    {
                        "mode": "shared", 
                        "resourceGroupId": selectedEvent?.subEvent?.id,
                        "experienceId": selectedEvent?.type?.experienceId,
                        "experienceName": selectedEvent?.event?.title,
                        "category": selectedEvent?.category?.name,
                        "totalCost": financeInfo?.totalCost,
                        "totalTax": financeInfo?.totalTax,
                        "sessionTime":  `${selectedEvent?.selectedDate}T${selectedEvent?.timeSlot?.startTime}`,
                        "sessionDuration": selectedEvent?.eventInfo?.firstAvailableDate?.sessions?.[0]?.duration ? 
                            selectedEvent?.eventInfo.firstAvailableDate.sessions[0].duration 
                            : (selectedEvent?.eventInfo?.resourceGroups?.[0]?.duration ? selectedEvent?.eventInfo.resourceGroups[0].duration : null)  ,
                        "participants": [...Array(participantCount)].map((_,index)=>{
                            return {
                                "priceTierName": priceTiersName[index], 
                                "firstName": selectedEvent.defaultQuestions.participants[index].firstName,
                                "lastName": selectedEvent.defaultQuestions.participants[index].lastName,
                                "customQuestionResponses": selectedEvent.participantAnswers[index]
                            }
                            }),
                        "additionalCustomQuestionResponses": selectedEvent?.purchaserAnswers,
                        "listingAddOns": selectedEvent?.addOns?.length > 0 ? 
                            selectedEvent.addOns.map(addOn => {
                                return {
                                    listingAddOnId : addOn.id, 
                                    quantity: addOn.quantity
                                }}) 
                            : []
                    }
                ]
            }

            const { data, error } = await dispatch(createWayBooking(payload));

            if (error) {
                updateFetchApiError(true, error);
                dispatch(sendAnalytics(WAY_ACTIVITIES, "CREATE BOOKING - FAILED", { element: "widget", widgetSessionId:  waySessionToken, "pageName": WAY_CREATE_BOOKING,  errorMessage: error }));
                return;
            }
            
            if(data?.bookingId){
                // Completed
                dispatch(sendAnalytics(WAY_ACTIVITIES, "CREATE BOOKING - SUCCESS", { element: "widget", widgetSessionId: waySessionToken, "pageName": WAY_CREATE_BOOKING,}));
                handleNext()
            }
            
        } catch (error) {
            // console.log(error)
            updateFetchApiError(true, error.message);
        } finally {
            updateLoaderState(false);
        }
    }

    const getEventsCallback = (status, data) => {
        updateLoaderState(false)
        setInitialLoading(false)

        if(!status){
            handleUpdatedSelectedEventObj({events: null, categories: []})
            updateFetchApiError(true, data, ()=> {
                updateFetchApiError(false)
                setCurrentPage("activitiesLevel0")
            });
            dispatch(sendAnalytics(WAY_ACTIVITIES, "GET EVENTS - FAILED", { element: "widget", widgetSessionId: waySessionToken, "pageName": WAY_EVENT_LIST, errorMessage: data }));
            return
        }

        dispatch(sendAnalytics(WAY_ACTIVITIES, "GET EVENTS - SUCCESS", { element: "widget", "pageName": WAY_EVENT_LIST, widgetSessionId: waySessionToken }));

        handleUpdatedSelectedEventObj({events: data, categories: Object.keys(data).map((item)=> { return {name: item, id: item}})})
    }


    const handleUpdateBooking = async (payload)=>{
        updateLoaderState(true, "Updating your booking...")

        try {
            const { data, error } = await dispatch(updateMyWayBooking(payload));
            if(error){
                updateFetchApiError(true, error);
                return
            }

            updateFetchApiError(true, data)

            initialiseActivities();
        } catch (err) {
            console.error("...", err);
            updateFetchApiError(true, err.message || "Something went wrong");
        } finally {
            updateLoaderState(false)
        }
    }

    const handleCancelBooking = async (data) => {
        updateLoaderState(true, "Cancelling your booking...");
        // console.log("Cancel booking", data)
        const payload = {
            bookingId: data.id
        }

        try {
            const {data, error} = await dispatch(cancelWayBooking(payload));

            if(error){
                updateFetchApiError(true, error);
                return
            }
            updateFetchApiError(true, data)

            initialiseActivities();
        } catch (err) {
            console.error("...", err);
            updateFetchApiError(true, err.message || "Something went wrong");
        } finally {
            updateLoaderState(false)
        }
    };

    useEffect(()=> {
        if(bookingOverviewDetails){
            setCurrentPage("activitiesLevelEdit");
        }
    }, [bookingOverviewDetails])

    const cancelBookingOnClick = (bookingOverviewDetails) => {
            // Are you sure
    
            updateFetchApiError(
                true, 
                "This will remove your current reservation schedule. Do you wish to proceed?",
                () => {
                    updateFetchApiError(false)
                    handleCancelBooking(bookingOverviewDetails)
                },
                "Continue",
                ()=> updateFetchApiError(false),
                "",
                "Cancel Reservation?"
            )
            
        }
    

    const getCurrentPage = () => {
        switch (currentPage) {
            case "activitiesLevel0":
                return (
                    <ActivitiesBookings
                        bookingOverviewDetails={bookingOverviewDetails}
                        setBookingOverviewDetails={setBookingOverviewDetails}
                        cancelBookingOnClick={cancelBookingOnClick}
                        updateLoaderState={updateLoaderState}
                        updateFetchApiError={updateFetchApiError}
                        handleRetryFetchBookings={handleRetryFetchBookings}
                        myBookings={myBookings}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}
                    />
                )
            case "activitiesLevelEdit":
                return (
                    <ActivitiesBookingOverviewPage
                        waySessionToken={waySessionToken}
                        updateLoaderState={updateLoaderState}
                        updateFetchApiError={updateFetchApiError}
                        bookingOverviewDetails={bookingOverviewDetails}
                        handleUpdateBooking={handleUpdateBooking}
                        handleGoBack={handleGoBack}
                    />
                )
            case "activitiesLevel1":
                return (
                    <ActivitiesEventList
                        loading={loaderState.showLoader}
                        events={selectedEvent?.events}
                        categories={selectedEvent?.categories}
                        handleNext={handleEventClick}
                        handleGoBack={handleGoBack}
                    />
                )
            case "activitiesLevel2":
                return (
                    <ActivitiesEventList2
                        events={selectedEvent?.eventInfo?.resourceGroups}
                        selectedEvent={selectedEvent}
                        setSelectedEvent={setSelectedEvent}
                        handleGetAvailability={handleGetAvailability}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}
                        currentPage={currentPage}
                    />
                )
            case "activitiesLevel3":
                dispatch(sendAnalytics(WAY_ACTIVITIES, "SLOT BOOKING", { element: "widget", "pageName": WAY_SLOT_BOOKING, widgetSessionId: waySessionToken }));
                return (
                    <ActivitiesCreateBooking 
                        selectedEvent={selectedEvent}
                        setSelectedEvent={setSelectedEvent}
                        participantCount={participantCount}
                        handleUpdatedSelectedEventObj={handleUpdatedSelectedEventObj}
                        availability={availability}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}
                    />
                )
            case "activitiesLevel4":
                dispatch(sendAnalytics(WAY_ACTIVITIES, "BOOKING DETAILS", { element: "widget", "pageName": WAY_ADDITIONAL_DETAILS, widgetSessionId: waySessionToken }));
                return (
                    <ActivitiesAdditionalDetails 
                        selectedEvent={selectedEvent}
                        participantCount={participantCount}
                        handleUpdatedSelectedEventObj={handleUpdatedSelectedEventObj}
                        handleNext={handleNext}
                        handleGoBack={handleGoBack}
                        getPriceTierName={getPriceTierName}
                    />
                )
            case "activitiesLevel5":
                dispatch(sendAnalytics(WAY_ACTIVITIES, "CONFIRM BOOKING", { element: "widget", "pageName": WAY_CREATE_BOOKING, widgetSessionId: waySessionToken }));
                return (
                    <ActivitiesConfirmBooking
                        selectedEvent={selectedEvent}
                        handleNext={handleCreateBooking}
                        handleGoBack={handleGoBack}
                    />
                )
            case "activitiesLevel6": 
                return (
                    <ActivititiesConfirmation 
                        handleNext={handleNext}
                    />
                )
        }
    }

    const handleNext = (data) => {
        switch (currentPage) {
            case "activitiesLevel0":
                if(!initialLoading){
                    updateLoaderState(true, "Fetching activities...");
                }
                dispatch(getEvents(null, getEventsCallback));
                resetAvailability()
                setCurrentPage("activitiesLevel1");
                return
            case "activitiesLevel1":
                if(data?.kind === "resource") {
                    setCurrentPage("activitiesLevel2");
                    return
                }
                setCurrentPage("activitiesLevel3")
                return
            case "activitiesLevel2":
                setCurrentPage("activitiesLevel3");
                return
            case "activitiesLevel3":
                setCurrentPage("activitiesLevel4");
                return
            case "activitiesLevel4":
                setCurrentPage("activitiesLevel5");
                return
            case "activitiesLevel5":
                updateLoaderState(true, "Fetching bookings...");
                dispatch(fetchBookings(initialiseActivitiesCallback));
                setCurrentPage("activitiesLevel6");
                return
            case "activitiesLevel6":
                setCurrentPage("activitiesLevel0");
                return
            default:
                dispatch(setGoHome(true));
                return
        }
    }

    const handleGoBack = () => {
        switch (currentPage) {
            case "activitiesLevelEdit":
                setBookingOverviewDetails(null);
                setCurrentPage("activitiesLevel0")
                return
            case "activitiesLevel1":
                if(!myBookings?.length){
                    dispatch(setGoHome(true));
                    return      
                }
                setCurrentPage("activitiesLevel0")
                return
            case "activitiesLevel2":
                resetSelectedEvent();
                resetAvailability();
                setCurrentPage("activitiesLevel1");
                return
            case "activitiesLevel3":
                if(selectedEvent?.event?.kind === "resource") {
                    setCurrentPage("activitiesLevel2");
                    return
                }
                resetSelectedEvent();
                resetAvailability();
                setCurrentPage("activitiesLevel1");
                return
            case "activitiesLevel4":
                setCurrentPage("activitiesLevel3");
                return
            case "activitiesLevel5":
                setCurrentPage("activitiesLevel4");
                return
            case "activitiesLevel6":
                setCurrentPage("activitiesLevel0");
                return
            default:
                dispatch(setGoHome(true));
                return
        }
    }

    const initialiseActivitiesCallback = (status, data) => {
        updateLoaderState(false);

        if(!status){
            setInitialLoading(false)
            updateFetchApiError(true, data)
            setCurrentPage("activitiesLevel0")
            dispatch(sendAnalytics(WAY_ACTIVITIES, "FETCH BOOKING - FAILED", { element: "widget", "pageName": WAY_MY_BOOKING, widgetSessionId: waySessionToken, errorMessage: data }));
            return
        }
        dispatch(sendAnalytics(WAY_ACTIVITIES, "FETCH BOOKING - SUCCESS", { element: "widget", "pageName": WAY_MY_BOOKING, widgetSessionId: waySessionToken }));
        if(!data?.length){
            handleNext("activitiesLevel1");
        } else {
            setInitialLoading(false);
        }
        setMyBookings(data);
    }

    const initialiseActivities = (initialLoading = false) => {
        try {
            resetSelectedEvent();
            setInitialLoading(initialLoading)
            if(!initialLoading){
                updateLoaderState(true, "Fetching bookings...");
            }

            if(currentPage !== "activitiesLevel0") setCurrentPage("activitiesLevel0");

            setBookingOverviewDetails(null);
            dispatch(fetchBookings(initialiseActivitiesCallback));
        } catch (error) {
            // console.log(error)
            updateFetchApiError(true, error?.message, handleGoBack)
            // updateLoaderState(false)
            setInitialLoading(false)
        }
    }

    const handleRetryFetchBookingsCallback = (status, data) => {
        updateLoaderState(false);

        if(!status){
            updateFetchApiError(true, data);
            dispatch(sendAnalytics(WAY_ACTIVITIES, "FETCH BOOKING RETRY - FAILED", { element: "widget", "pageName": WAY_MY_BOOKING, widgetSessionId: waySessionToken, errorMessage: data }));
            return
        }

        dispatch(sendAnalytics(WAY_ACTIVITIES, "FETCH BOOKING RETRY - SUCCESS", { element: "widget", "pageName": WAY_MY_BOOKING, widgetSessionId: waySessionToken }));
        setMyBookings(data);
    }

    const handleRetryFetchBookings = () => {
        try {
            resetSelectedEvent();
            updateLoaderState(true, "Fetching bookings...");
            setBookingOverviewDetails(null);
            dispatch(fetchBookings(handleRetryFetchBookingsCallback));
        } catch (error) {
            updateFetchApiError(true, error?.message, handleGoBack)
        }
    }

    useEffect(()=> {
        if (!isLoggedIn) {
            dispatch(setGoHome(true));
            dispatch(setShowLoginModal(true));
            return;
        }
        initialiseActivities(true)

        dispatch(sendAnalytics(WAY_ACTIVITIES, CLICKED, { element: "widget", "widgetSessionId": waySessionToken}))

        return () => {
            const widgetCloseTime = new Date;
            const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
            dispatch(sendAnalytics(WAY_ACTIVITIES, EXIT, { element: "widget", duration: widgetCloseDuration, widgetSessionId: waySessionToken }))
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(()=>{
        if (selectedEvent.priceTiers) {
            const participantCount = selectedEvent.priceTiers.reduce((acc, curr)=> acc + curr.quantity, 0) 
            setParticipantCount(participantCount)
        } else {
            setParticipantCount(null);
        }
    }, [selectedEvent.priceTiers])

    const getDefaultQuestionsFormat = (count) => {
        return {
            participants: [...Array(count)].map((_,i)=>{
                return {
                    firstName: "",
                    lastName: ""
                }
            })
        }
    }

    useEffect(()=>{
        if(participantCount){
            function findAddOnMaxQuantity(limit){
                if(limit.type == "PER_BOOKING") return limit.value;
                if(limit.type == "PER_PARTICIPANT") return limit.value * participantCount;
            }
        
            let addOnsInitialTemplate = []
            if(selectedEvent?.eventInfo?.addOns.length > 0 ){
                
                addOnsInitialTemplate = selectedEvent?.eventInfo?.addOns.map((addOn)=>{
                    return {
                        ...addOn,
                        maxQuantity: addOn?.limit?.value ? findAddOnMaxQuantity(addOn.limit) : 1000000,
                        quantity: 0
                    }
                })
        
            }

            handleUpdatedSelectedEventObj({
                defaultQuestions: getDefaultQuestionsFormat(participantCount),
                addOns: addOnsInitialTemplate
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [participantCount])



    return (<>

            {getCurrentPage()}

            {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
            {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN)}

            {fetchApiError.errorStatus && 
                <InfoPopupModal
                    title={fetchApiError.errorMessageTitle}
                    subtitle={fetchApiError.errorMessage} 
                    onContinue={fetchApiError.onContinueFunc ? fetchApiError.onContinueFunc : () => updateFetchApiError(false)}
                    primaryBtnLabel={fetchApiError.primaryBtnLabel ? fetchApiError.primaryBtnLabel : "Close"} 
                    onClose={fetchApiError.onCloseFunc ? fetchApiError.onCloseFunc : null}
                    secondaryBtnLabel={fetchApiError.secondaryBtnLabel ? fetchApiError.secondaryBtnLabel : null}
                    OnRequestClose={fetchApiError.onContinueFunc ? fetchApiError.onContinueFunc : () => updateFetchApiError(false)}
            />}
        </>
    )
}

export default Activities
